type Props = {
    children: React.ReactNode;
    selected?: boolean;
    onClick?: () => void;
    disabled?: boolean;
};

export default function Card({ children, selected, disabled, onClick }: Readonly<Props>) {
    return (
        <button
            disabled={disabled}
            onClick={onClick}
            className={[
                'card relative w-16 h-24 sm:w-20 sm:h-28 flex items-center justify-center text-lg font-semibold transition',
                selected ? 'ring-2 ring-indigo-600 scale-[1.03]' : 'hover:scale-[1.02]',
                disabled ? 'opacity-60 cursor-not-allowed' : ''
            ].join(' ')}
        >

            <span className="absolute top-1 left-1 text-xs font-bold ">
                {children}
            </span>
            <span className="absolute top-1 right-1 text-xs font-bold ">
                {children}
            </span>
            <span className="absolute bottom-1 left-1 text-xs font-bold transform rotate-180">
                {children}
            </span>
            <span className="absolute bottom-1 right-1 text-xs font-bold transform rotate-180">
                {children}
            </span>
            <div className="flex items-center justify-center text-4xl font-semibold">
                {children}
            </div>
        </button>
    );
}
